<template>
  <div id="app">
<!--    <img alt="Vue logo" src="./assets/logo.png">
    <HelloWorld msg="Welcome to Your Vue.js App"/>-->
<!--    <DataBoard/>-->
<!--    <production-situation/>-->
    <router-view/>
  </div>
</template>

<script>
// import DataBoard from "@/views/data-board/index.vue";
// import ProductionSituation from "@/views/production-situation/index.vue";

export default {
  name: 'App',
  components: {
    // ProductionSituation,
    // DataBoard
  }
}
</script>

<style>
body,html {
  margin: 0 auto;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  height: 100vh;
}
</style>
